import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { findNewerBuild, reloadForBuild } from "@/lib/appUpdate"

const CHECK_INTERVAL_MS = 30 * 60 * 1000

/**
 * Recharge l'app sur la nouvelle version — au changement d'écran suivant, jamais au
 * milieu d'un écran : quitter un écran abandonne déjà son état, le rechargement ne
 * fait rien perdre de plus. Vérifié au démarrage, au retour au premier plan et toutes
 * les 30 min. Jamais en entrant ou en sortant d'une séance en cours.
 */
export function useAppUpdate() {
  const location = useLocation()
  const newerBuild = useRef<string | null>(null)
  const previousPath = useRef(location.pathname)

  useEffect(() => {
    const check = () => {
      if (document.visibilityState !== "visible" || newerBuild.current) return
      void findNewerBuild().then((build) => {
        if (build) newerBuild.current = build
      })
    }
    check()
    document.addEventListener("visibilitychange", check)
    const id = window.setInterval(check, CHECK_INTERVAL_MS)
    return () => {
      document.removeEventListener("visibilitychange", check)
      window.clearInterval(id)
    }
  }, [])

  useEffect(() => {
    const from = previousPath.current
    const to = location.pathname
    previousPath.current = to
    if (from === to || !newerBuild.current) return
    if (from === "/dashboard/session" || to === "/dashboard/session") return
    reloadForBuild(newerBuild.current)
  }, [location.pathname])
}
